import { devEnvFlags } from './constants/devEnvFlags';
import { prodEnvFlags } from './constants/prodEnvFlags';
export let ACTIVE_FLAGS;
export const initFeatureFlagClient = (isDev = false) => {
    ACTIVE_FLAGS = isDev ? devEnvFlags : prodEnvFlags;
};
